export const DEBOUNCE_TIMEOUT = 500;

export const SKELETON_ROWS_FALLBACK = 10;
